import(/* webpackMode: "eager" */ "/vercel/path0/volya-frontend/app/page.tsx");
